import switchColors from './switch-colors';
// import secondaryColors from '@/colors/js/utils/secondary-colors';

const safelySwitchTheme = async (theme) => {
  const useLegacy = false; // theme !== 'default';
  let colors = {};
  let localColors = {};
  // let secColors = {};    // enable if necessary
  try {
    const { default: c } = await import(`@uikit/ui-kit/colors/js/${useLegacy ? 'legacy/' : ''}${theme}.js`);
    colors = c;
  } catch (e) {
    // eslint-disable-next-line
    console.warn(`UI Kit missing theme: ${theme}`);
  }
  try {
    const { default: c } = await import(`@/colors/js/${useLegacy ? 'legacy/' : ''}${theme}.js`);
    localColors = c;
  } catch (e) {
    // eslint-disable-next-line
    console.warn(`Missing MotionTracker theme: ${theme}`);
  }
  /*
  // enable if necessary
  try {
    secColors = secondaryColors();
  } catch (e) {
    // eslint-disable-next-line
    console.warn('Missing secondary colors');
  }
  */

  switchColors({
    ...colors,
    ...localColors,
    // ...secColors,  // enable if necessary
  });
};

export default safelySwitchTheme;
